module.exports = __webpack_public_path__ + "img/icon-excel.d899229f.svg";